import React, { useEffect, useState } from "react";
import {
  Container,
  IconButton,
  Typography,
} from "@material-ui/core";

import {
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";

import ProductCard, {
  Product,
} from "./ProductCard";

interface ProductSectionProps {
  eyebrow?: string;
  title: string;
  products: Product[];
  onAddToCart?: (product: Product) => void;
}

const PRODUCTS_PER_PAGE = 5;

const ProductSection: React.FC<ProductSectionProps> = ({
  eyebrow,
  title,
  products,
  onAddToCart,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = Math.ceil(
    products.length / PRODUCTS_PER_PAGE
  );

  const startIndex =
    currentPage * PRODUCTS_PER_PAGE;

  const visibleProducts = products.slice(
    startIndex,
    startIndex + PRODUCTS_PER_PAGE
  );

  const handlePrevious = () => {
    setCurrentPage((prev) =>
      Math.max(prev - 1, 0)
    );
  };

  const handleNext = () => {
    setCurrentPage((prev) =>
      Math.min(prev + 1, totalPages - 1)
    );
  };

  // If products change and current page becomes invalid
  useEffect(() => {
    if (currentPage >= totalPages && totalPages > 0) {
      setCurrentPage(totalPages - 1);
    }
  }, [products.length, totalPages, currentPage]);

  return (
    <section className="product-section">
      <Container maxWidth="lg">

        {/* =========================================
            SECTION HEADER
        ========================================= */}

        <div className="products-section-header">

          <div className="products-heading-content">

            {eyebrow && (
              <Typography className="section-eyebrow">
                {eyebrow}
              </Typography>
            )}

            <Typography className="section-title">
              {title}
            </Typography>

          </div>

          {/* Horizontal line */}

          <div className="section-heading-line" />

          {/* =====================================
              ARROW BUTTONS
          ===================================== */}

          <div className="products-slider-buttons">

            <IconButton
              className="product-slider-button"
              onClick={handlePrevious}
              disabled={currentPage === 0}
            >
              <ChevronLeft />
            </IconButton>

            <IconButton
              className="product-slider-button"
              onClick={handleNext}
              disabled={
                currentPage >= totalPages - 1
              }
            >
              <ChevronRight />
            </IconButton>

          </div>

        </div>

        {/* =========================================
            PRODUCTS
        ========================================= */}

        <div className="products-grid">

          {visibleProducts.map((product) => (
            <div
              key={product.id}
              className="product-grid-item"
            >
              <ProductCard
                product={product}
                onAddToCart={onAddToCart}
              />
            </div>
          ))}

        </div>

      </Container>
    </section>
  );
};

export default ProductSection;